<mat-form-field>
  <mat-date-range-input [rangePicker]="picker" [max]="max ? max : today">
    <input matStartDate [(ngModel)]="fromDate" placeholder="{{ 'itemFilter.fromDate' | translate }}" (dateChange)="onDateChange()" />
    <input matEndDate [(ngModel)]="toDate" placeholder="{{ 'itemFilter.toDate' | translate }}" (dateChange)="onDateChange()" />
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker (closed)="close()" #picker></mat-date-range-picker>
</mat-form-field>
